import { render, staticRenderFns } from "./serverDeployDetails.vue?vue&type=template&id=08b2cca2&"
import script from "./serverDeployDetails.vue?vue&type=script&lang=js&"
export * from "./serverDeployDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports